import { createFileRoute } from "@tanstack/react-router"
import { SubmissionsPage } from "@/admin"
import type { AdminSubmissionsSearch } from "@/admin"

export const Route = createFileRoute("/(user)/admin/submissions")({
  validateSearch: (search): AdminSubmissionsSearch => ({
    status:
      search.status === "evaluated" || search.status === "all"
        ? search.status
        : undefined,
    tenantId: typeof search.tenantId === "string" ? search.tenantId : undefined,
    // Default is oldest-first, so only the newest-first override is stored
    oldestFirst: search.oldestFirst === false ? false : undefined,
    page:
      typeof search.page === "number" && search.page > 1
        ? search.page
        : undefined,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <SubmissionsPage
      search={search}
      onSearchChange={(partial) => {
        void navigate({ search: (prev) => ({ ...prev, ...partial }) })
      }}
    />
  )
}
